import * as yup from 'yup';

export default function nullableEmail(label) {
  return yup.string().max(75).email(label).label(label).nullable();
}
